
export class IrmaStatusCode {
    readonly ALRIGHT: StatusCodeDescription = { code: 0, translate: 'AllRight' };
    readonly SABOTAGE: StatusCodeDescription = { code: 1, translate: 'Sabotage' };
    readonly PRIMARY_CONFIG_INVALID: StatusCodeDescription = { code: 2, translate: 'PrimaryCfgInValid' };
    readonly BACKUP_CONFIG_INVALID: StatusCodeDescription = { code: 3, translate: 'BackupCfgInValid' };
    readonly IN_SERVICE_MODE: StatusCodeDescription = { code: 4, translate: 'InServiceMode' };
    readonly BAD_PARAM_IN_CONFIG: StatusCodeDescription = { code: 5, translate: 'BadParamInCfg' };
    readonly ANY_CONFIG_INVALID: StatusCodeDescription = { code: 6, translate: 'AnyCfgInvalid' };
    readonly MAX_TEMP_EXCEEDED: StatusCodeDescription = { code: 7, translate: 'MaxTempExceeded' };
    readonly MAX_TEMP_EXCEEDED_CURRENTLY: StatusCodeDescription = { code: 8, translate: 'MaxTempExceededCurrently' };
    readonly FPGA_WAS_RESTARTED: StatusCodeDescription = { code: 9, translate: 'FPGAwasRestarted' };
    readonly UNDER_VOLTAGE_WAS_DETECTED: StatusCodeDescription = { code: 10, translate: 'UndervoltageWasDetected' };
    readonly CONNECTION_ONLY: StatusCodeDescription = { code: 11, translate: 'ConnectionOnly' };
    readonly SENSOR_OUT_OF_ORDER: StatusCodeDescription = { code: 253, translate: 'SensorOutOfOrder' }; //  UI16_MAX-2
    readonly CONNECTION_LOST: StatusCodeDescription = { code: 254, translate: 'ConnectionLost' }; //  UI16_MAX-2
    readonly UNKNOWN: StatusCodeDescription = { code: 255, translate: 'Unknown' }; //  UI16_MAX-1
    readonly UNEXPECTED_CODE: StatusCodeDescription = { code: 404040404, translate: 'UnexpectedCode' };

    private allStatuses = [this.ALRIGHT, this.SABOTAGE, this.PRIMARY_CONFIG_INVALID, this.BACKUP_CONFIG_INVALID,
    this.IN_SERVICE_MODE, this.BAD_PARAM_IN_CONFIG, this.ANY_CONFIG_INVALID, this.MAX_TEMP_EXCEEDED,
    this.MAX_TEMP_EXCEEDED_CURRENTLY, this.FPGA_WAS_RESTARTED, this.UNDER_VOLTAGE_WAS_DETECTED, this.CONNECTION_ONLY,
    this.SENSOR_OUT_OF_ORDER, this.CONNECTION_LOST, this.UNKNOWN, this.UNDER_VOLTAGE_WAS_DETECTED];

    getOpionsForFieldIrmaStatusCode(): Record<number, number> {
        const object = {};
        this.allStatuses
            .filter(code => code !== this.UNEXPECTED_CODE && code !== this.ALRIGHT)
            .forEach(code => {
                object[code.code] = code.code;
            });
        return object;
    }

    getOpionsForFieldIrma(): Record<number, string> {
        const object = {};
        this.allStatuses
            .filter(code => code !== this.UNEXPECTED_CODE)
            .forEach(code => {
                object[code.code] = code.translate;
            });
        return object;
    }

    getOpionsForFieldIrmaCodeDescription(): Record<number, string> {
        const object = {};
        this.allStatuses
            .filter(code => code !== this.UNEXPECTED_CODE && code !== this.ALRIGHT)
            .forEach(code => {
                object[code.code] = code.translate;
            });
        return object;
    }
}

interface StatusCodeDescription {
    code: number;
    translate: string;
}
